//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { gql } from 'graphql-tag'
import { Language, ContentType } from '@constants'

const BACKGROUND_ARTICLES = gql`
  query ($first: Int, $where: ArticleFilterInput, $order: [ArticleSortInput!]) {
    articles(first: $first, where: $where, order: $order) {
      nodes {
        id
        externalId
        date
        title
        slug
        contentType {
          id
          name
          contentTypeGroup {
            id
            name
          }
        }
      }
    }
  }
`

export default {
  name: 'ContentTypeSidebar',
  props: {
    background: {
      type: String,
      default: ''
    },
    customClass: {
      type: String,
      default: ''
    },
    contentTypeId: {
      type: Number,
      default: ContentType.BACKGROUND
    }
  },
  data() {
    return {
      articles: [],
      animated: true,
      showPlaceholder: true,
      placeholders: 2,
      ContentType
    }
  },
  fetchOnServer: false,
  async fetch() {
    if (!this.canShow) return
    await this.refresh()
  },
  computed: {
    language() {
      return this.$store.get('language/locale') || 'en'
    },
    languageId() {
      return this.language === 'en' ? Language.ENGLISH : Language.DUTCH
    },
    currentBreakPoint() {
      return this.$store.get('app/currentBreakPoint') || 'md'
    },
    cardClass() {
      const classes = []

      if (this.background) classes.push(this.background)
      if (this.customClass) classes.push(this.customClass)

      return classes.join(' ')
    },
    canShow() {
      return (
        typeof navigator !== 'undefined' &&
        !navigator.userAgent.includes('Chrome-Lighthouse') &&
        !navigator.userAgent.includes('Googlebot')
      )
    }
  },
  watch: {
    async languageId() {
      await this.refresh(true)
    }
  },
  methods: {
    async refresh(purge = false) {
      this.showPlaceholder = true

      const where = {
        contentTypeId: {
          eq: this.contentTypeId
        }
      }

      if (this.languageId != null) {
        where.language = {
          id: {
            eq: this.languageId
          }
        }
      }

      try {
        const { data } = await this.$apollo.query({
          query: BACKGROUND_ARTICLES,
          variables: {
            first: 4,
            where,
            order: [
              {
                date: 'DESC'
              }
            ]
          },
          fetchPolicy: purge ? 'network-only' : 'cache-first'
        })

        this.articles = data.articles.nodes
      } catch (error) {
        this.handleError(error)
      } finally {
        this.showPlaceholder = false
      }
    }
  }
}
